import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p',
  'div',
  'span',
  'br',
  'hr',
  'strong',
  'b',
  'em',
  'i',
  'u',
  's',
  'strike',
  'del',
  'font',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'blockquote',
  'pre',
  'code',
  'a',
  'img',
  'video',
  'source',
  'figure',
  'figcaption',
  'table',
  'thead',
  'tbody',
  'tr',
  'th',
  'td',
  'sub',
  'sup',
  'section',
  'footer',
];

const ALLOWED_ATTR = [
  'class',
  'style',
  'href',
  'target',
  'rel',
  'title',
  'src',
  'alt',
  'controls',
  'poster',
  'width',
  'height',
  'colspan',
  'rowspan',
  'role',
  'tabindex',
  'data-hashtag-slug',
  'data-hashtag-label',
];

const PURIFY_CONFIG = {
  ALLOWED_TAGS,
  ALLOWED_ATTR,
  ALLOW_DATA_ATTR: false,
  ALLOW_UNKNOWN_PROTOCOLS: false,
};

export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, PURIFY_CONFIG);
}
